var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "board-page-detail" } },
    [
      _c("div", { staticClass: "board-page-detail--header" }, [
        _vm.isDetail
          ? _c("div", { staticStyle: { height: "42px" } }, [
              _c("h4", [_vm._v(_vm._s(_vm.board.name))]),
              _vm._v(" "),
              _c("p", [_vm._v("ID: " + _vm._s(_vm.board.id))])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.isDetail
        ? _c("j-tabs", { attrs: { tabs: _vm.tabs } }, [
            _c(
              "div",
              {
                staticClass: "tab-content",
                attrs: { id: "tabs-component-container" }
              },
              _vm._l(_vm.tabs, function(i) {
                return _c(
                  "div",
                  {
                    key: i.id,
                    staticClass: "tab-pane",
                    attrs: {
                      id: i.idComp,
                      "aria-labelledby": i.idTab,
                      role: "tabpanel"
                    }
                  },
                  [
                    _c(i.comp.name, {
                      tag: "component",
                      attrs: { board: _vm.board }
                    })
                  ],
                  1
                )
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("j-loading-screen", {
        ref: "loading",
        attrs: { message: _vm.loadingMessage }
      }),
      _vm._v(" "),
      _c("j-problem-screen", {
        ref: "problem",
        attrs: { message: _vm.problemMessage }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8aba479c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8aba479c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/jBoardSettingDetail.vue
// module id = null
// module chunks = 